import { render, staticRenderFns } from "./DefaultAside.vue?vue&type=template&id=74c296ab&"
import script from "./DefaultAside.vue?vue&type=script&lang=js&"
export * from "./DefaultAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c296ab')) {
      api.createRecord('74c296ab', component.options)
    } else {
      api.reload('74c296ab', component.options)
    }
    module.hot.accept("./DefaultAside.vue?vue&type=template&id=74c296ab&", function () {
      api.rerender('74c296ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/DefaultAside.vue"
export default component.exports